<ng-template #settingsTemplate>
    <app-tool-setting label="Hoogte" class="tool-setting-groups">
        <div class="tool-setting-group">
            <app-radio-input
                [value]="3"
                [model]="numRows"
                (selected)="setNumRows(3)"
                >3 rijen</app-radio-input
            >
            <app-radio-input
                [value]="4"
                [model]="numRows"
                (selected)="setNumRows(4)"
                >4 rijen</app-radio-input
            >
        </div>
        <div class="tool-setting-group">
            <app-radio-input
                [value]="5"
                [model]="numRows"
                (selected)="setNumRows(5)"
                >5 rijen</app-radio-input
            >
        </div>
    </app-tool-setting>
    <app-tool-setting label="Vul in">
        <app-numbers-input
            (numberChoice)="handleNumberChoice($event)"
            (undo)="handleUndo()"
            (clear)="handleClear()"
        ></app-numbers-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    @if (numRows === 3) {
    <svg
        id="Laag_1"
        data-name="Laag 1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 244 154"
        style="height: 160px"
    >
        <defs>
            <style>
                .nWall3-1,
                .nWall3-7 {
                    fill: none;
                }
                .nWall3-2 {
                    fill: #fff;
                    stroke: #0090c9;
                    stroke-width: 1.5px;
                }
                .nWall3-3 {
                    font-size: 28px;
                    font-family: UniversLTStd, Univers LT Std;
                }
                .nWall3-4 {
                    letter-spacing: -0.13em;
                }
                .nWall3-5 {
                    letter-spacing: -0.01em;
                }
                .nWall3-6 {
                    clip-path: url(#clip-path);
                }
                .nWall3-7 {
                    stroke: #a1a1a1;
                }
                .nWall3-8 {
                    clip-path: url(#clip-path-2);
                }
                .nWall3-9 {
                    clip-path: url(#clip-path-3);
                }
                .nWall3-10 {
                    clip-path: url(#clip-path-4);
                }
                .nWall3-11 {
                    clip-path: url(#clip-path-5);
                }
                .nWall3-12 {
                    clip-path: url(#clip-path-6);
                }
            </style>
            <clipPath id="clip-path" transform="translate(-1)">
                <rect
                    class="nWall3-1"
                    x="61.83"
                    y="91.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-2" transform="translate(-1)">
                <rect
                    class="nWall3-1"
                    x="144.83"
                    y="91.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-3" transform="translate(-1)">
                <rect
                    class="nWall3-1"
                    x="103.58"
                    y="38.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-4" transform="translate(-1)">
                <rect
                    class="nWall3-1"
                    x="103.83"
                    y="144.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-5" transform="translate(-1)">
                <rect
                    class="nWall3-1"
                    x="20.83"
                    y="144.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-6" transform="translate(-1)">
                <rect
                    class="nWall3-1"
                    x="187.08"
                    y="144.66"
                    width="39"
                    height="1"
                />
            </clipPath>
        </defs>
        <g class="number-wall-3-fields">
            <g class="field1" (click)="setActiveField(0)">
                <rect
                    class="nWall3-2"
                    x="83.75"
                    y="0.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall3-3"
                    text-anchor="middle"
                    transform="translate(122.25 35.52)"
                >
                    {{ values[0] }}
                </text>
                @if (activeField === 0) {
                <g>
                    <line
                        class="nWall3-7"
                        x1="102.58"
                        y1="39.16"
                        x2="141.58"
                        y2="39.16"
                    />
                </g>
                }
            </g>
            <g class="field2" (click)="setActiveField(1)">
                <rect
                    class="nWall3-2"
                    x="42.08"
                    y="53.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall3-3"
                    text-anchor="middle"
                    transform="translate(80.25 88.52)"
                >
                    {{ values[1] }}
                </text>
                @if (activeField === 1) {
                <g>
                    <line
                        class="nWall3-7"
                        x1="60.83"
                        y1="92.16"
                        x2="99.83"
                        y2="92.16"
                    />
                </g>
                }
            </g>
            <g class="field3" (click)="setActiveField(2)">
                <rect
                    class="nWall3-2"
                    x="125.25"
                    y="53.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall3-3"
                    text-anchor="middle"
                    transform="translate(164.25 88.52)"
                >
                    {{ values[2] }}
                </text>
                @if (activeField === 2) {
                <g>
                    <line
                        class="nWall3-7"
                        x1="143.83"
                        y1="92.16"
                        x2="182.83"
                        y2="92.16"
                    />
                </g>
                }
            </g>
            <g class="field4" (click)="setActiveField(3)">
                <rect
                    class="nWall3-2"
                    x="0.75"
                    y="106.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall3-3"
                    text-anchor="middle"
                    transform="translate(38.25 141.52)"
                >
                    {{ values[3] }}
                </text>
                @if (activeField === 3) {
                <g>
                    <line
                        class="nWall3-7"
                        x1="19.83"
                        y1="145.16"
                        x2="58.83"
                        y2="145.16"
                    />
                </g>
                }
            </g>
            <g class="field5" (click)="setActiveField(4)">
                <rect
                    class="nWall3-2"
                    x="83.75"
                    y="106.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall3-3"
                    text-anchor="middle"
                    transform="translate(122.25 141.52)"
                >
                    {{ values[4] }}
                </text>
                @if (activeField === 4) {
                <g>
                    <line
                        class="nWall3-7"
                        x1="102.83"
                        y1="145.16"
                        x2="141.83"
                        y2="145.16"
                    />
                </g>
                }
            </g>
            <g class="field6" (click)="setActiveField(5)">
                <rect
                    class="nWall3-2"
                    x="166.75"
                    y="106.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall3-3"
                    text-anchor="middle"
                    transform="translate(205.25 141.52)"
                >
                    {{ values[5] }}
                </text>
                @if (activeField === 5) {
                <g>
                    <line
                        class="nWall3-7"
                        x1="186.08"
                        y1="145.16"
                        x2="225.08"
                        y2="145.16"
                    />
                </g>
                }
            </g>
        </g>
    </svg>
    } @if (numRows === 4) {
    <svg
        id="Laag_1"
        data-name="Laag 1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 327 207"
        style="height: 210px"
    >
        <defs>
            <style>
                .nWall4-1,
                .nWall4-5 {
                    fill: none;
                }
                .nWall4-2 {
                    fill: #fff;
                    stroke: #0090c9;
                    stroke-width: 1.5px;
                }
                .nWall4-3 {
                    font-size: 28px;
                    font-family: UniversLTStd, Univers LT Std;
                }
                .nWall4-4 {
                    clip-path: url(#clip-path);
                }
                .nWall4-5 {
                    stroke: #a1a1a1;
                }
                .nWall4-6 {
                    clip-path: url(#clip-path-2);
                }
                .nWall4-7 {
                    clip-path: url(#clip-path-3);
                }
                .nWall4-8 {
                    clip-path: url(#clip-path-4);
                }
                .nWall4-9 {
                    clip-path: url(#clip-path-5);
                }
                .nWall4-10 {
                    clip-path: url(#clip-path-6);
                }
                .nWall4-11 {
                    clip-path: url(#clip-path-7);
                }
                .nWall4-12 {
                    clip-path: url(#clip-path-8);
                }
                .nWall4-13 {
                    clip-path: url(#clip-path-9);
                }
                .nWall4-14 {
                    clip-path: url(#clip-path-10);
                }
            </style>
            <clipPath id="clip-path" transform="translate(-0.5)">
                <rect
                    class="nWall4-1"
                    x="102.83"
                    y="91.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-2" transform="translate(-0.5)">
                <rect
                    class="nWall4-1"
                    x="185.92"
                    y="91.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-3" transform="translate(-0.5)">
                <rect
                    class="nWall4-1"
                    x="144.58"
                    y="38.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-4" transform="translate(-0.5)">
                <rect
                    class="nWall4-1"
                    x="144.83"
                    y="144.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-5" transform="translate(-0.5)">
                <rect
                    class="nWall4-1"
                    x="61.83"
                    y="144.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-6" transform="translate(-0.5)">
                <rect
                    class="nWall4-1"
                    x="228.08"
                    y="144.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-7" transform="translate(-0.5)">
                <rect
                    class="nWall4-1"
                    x="185.83"
                    y="197.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-8" transform="translate(-0.5)">
                <rect
                    class="nWall4-1"
                    x="269.08"
                    y="197.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-9" transform="translate(-0.5)">
                <rect
                    class="nWall4-1"
                    x="19.83"
                    y="197.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-10" transform="translate(-0.5)">
                <rect
                    class="nWall4-1"
                    x="103.08"
                    y="197.66"
                    width="39"
                    height="1"
                />
            </clipPath>
        </defs>
        <g class="number-wall-4-fields">
            <g class="field1" (click)="setActiveField(0)">
                <rect
                    class="nWall4-2"
                    x="125.25"
                    y="0.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall4-3"
                    text-anchor="middle"
                    transform="translate(163.25 35.52)"
                >
                    {{ values[0] }}
                </text>
                @if (activeField === 0) {
                <g>
                    <line
                        class="nWall4-5"
                        x1="144.08"
                        y1="39.16"
                        x2="183.08"
                        y2="39.16"
                    />
                </g>
                }
            </g>
            <g class="field2" (click)="setActiveField(1)">
                <rect
                    class="nWall4-2"
                    x="83.58"
                    y="53.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall4-3"
                    text-anchor="middle"
                    transform="translate(121.25 88.52)"
                >
                    {{ values[1] }}
                </text>
                @if (activeField === 1) {
                <g>
                    <line
                        class="nWall4-5"
                        x1="102.33"
                        y1="92.16"
                        x2="141.33"
                        y2="92.16"
                    />
                </g>
                }
            </g>
            <g class="field3" (click)="setActiveField(2)">
                <rect
                    class="nWall4-2"
                    x="166.67"
                    y="53.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall4-3"
                    text-anchor="middle"
                    transform="translate(204.25 88.52)"
                >
                    {{ values[2] }}
                </text>
                @if (activeField === 2) {
                <g>
                    <line
                        class="nWall4-5"
                        x1="185.42"
                        y1="92.16"
                        x2="224.42"
                        y2="92.16"
                    />
                </g>
                }
            </g>
            <g class="field4" (click)="setActiveField(3)">
                <rect
                    class="nWall4-2"
                    x="42.25"
                    y="106.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall4-3"
                    text-anchor="middle"
                    transform="translate(80.25 141.52)"
                >
                    {{ values[3] }}
                </text>
                @if (activeField === 3) {
                <g>
                    <line
                        class="nWall4-5"
                        x1="61.33"
                        y1="145.16"
                        x2="100.33"
                        y2="145.16"
                    />
                </g>
                }
            </g>
            <g class="field5" (click)="setActiveField(4)">
                <rect
                    class="nWall4-2"
                    x="125.25"
                    y="106.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall4-3"
                    text-anchor="middle"
                    transform="translate(163.25 141.52)"
                >
                    {{ values[4] }}
                </text>
                @if (activeField === 4) {
                <g>
                    <line
                        class="nWall4-5"
                        x1="144.33"
                        y1="145.16"
                        x2="183.33"
                        y2="145.16"
                    />
                </g>
                }
            </g>
            <g class="field6" (click)="setActiveField(5)">
                <rect
                    class="nWall4-2"
                    x="208.25"
                    y="106.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall4-3"
                    text-anchor="middle"
                    transform="translate(246.25 141.52)"
                >
                    {{ values[5] }}
                </text>
                @if (activeField === 5) {
                <g>
                    <line
                        class="nWall4-5"
                        x1="227.58"
                        y1="145.16"
                        x2="266.58"
                        y2="145.16"
                    />
                </g>
                }
            </g>
            <g class="field7" (click)="setActiveField(6)">
                <rect
                    class="nWall4-2"
                    x="0.75"
                    y="159.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall4-3"
                    text-anchor="middle"
                    transform="translate(38.25 194.52)"
                >
                    {{ values[6] }}
                </text>
                @if (activeField === 6) {
                <g>
                    <line
                        class="nWall4-5"
                        x1="19.33"
                        y1="198.16"
                        x2="58.33"
                        y2="198.16"
                    />
                </g>
                }
            </g>
            <g class="field8" (click)="setActiveField(7)">
                <rect
                    class="nWall4-2"
                    x="83.75"
                    y="159.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall4-3"
                    text-anchor="middle"
                    transform="translate(121.25 194.52)"
                >
                    {{ values[7] }}
                </text>
                @if (activeField === 7) {
                <g>
                    <line
                        class="nWall4-5"
                        x1="102.58"
                        y1="198.16"
                        x2="141.58"
                        y2="198.16"
                    />
                </g>
                }
            </g>
            <g class="field9" (click)="setActiveField(8)">
                <rect
                    class="nWall4-2"
                    x="166.75"
                    y="159.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall4-3"
                    text-anchor="middle"
                    transform="translate(204.25 194.52)"
                >
                    {{ values[8] }}
                </text>
                @if (activeField === 8) {
                <g>
                    <line
                        class="nWall4-5"
                        x1="185.33"
                        y1="198.16"
                        x2="224.33"
                        y2="198.16"
                    />
                </g>
                }
            </g>
            <g class="field10" (click)="setActiveField(9)">
                <rect
                    class="nWall4-2"
                    x="249.75"
                    y="159.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall4-3"
                    text-anchor="middle"
                    transform="translate(287.25 194.52)"
                >
                    {{ values[9] }}
                </text>
                @if (activeField === 9) {
                <g>
                    <line
                        class="nWall4-5"
                        x1="268.58"
                        y1="198.16"
                        x2="307.58"
                        y2="198.16"
                    />
                </g>
                }
            </g>
        </g>
    </svg>
    } @if (numRows === 5) {
    <svg
        id="Laag_1"
        data-name="Laag 1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 410 260"
        style="height: 260px"
    >
        <defs>
            <style>
                .nWall5-1,
                .nWall5-5 {
                    fill: none;
                }
                .nWall5-2 {
                    fill: #fff;
                    stroke: #0090c9;
                    stroke-width: 1.5px;
                }
                .nWall5-3 {
                    font-size: 28px;
                    font-family: UniversLTStd, Univers LT Std;
                }
                .nWall5-4 {
                    clip-path: url(#clip-path);
                }
                .nWall5-5 {
                    stroke: #a1a1a1;
                }
                .nWall5-6 {
                    clip-path: url(#clip-path-2);
                }
                .nWall5-7 {
                    clip-path: url(#clip-path-3);
                }
                .nWall5-8 {
                    clip-path: url(#clip-path-4);
                }
                .nWall5-9 {
                    clip-path: url(#clip-path-5);
                }
                .nWall5-10 {
                    clip-path: url(#clip-path-6);
                }
                .nWall5-11 {
                    clip-path: url(#clip-path-7);
                }
                .nWall5-12 {
                    clip-path: url(#clip-path-8);
                }
                .nWall5-13 {
                    clip-path: url(#clip-path-9);
                }
                .nWall5-14 {
                    clip-path: url(#clip-path-10);
                }
                .nWall5-15 {
                    clip-path: url(#clip-path-11);
                }
                .nWall5-16 {
                    clip-path: url(#clip-path-12);
                }
                .nWall5-17 {
                    clip-path: url(#clip-path-13);
                }
                .nWall5-18 {
                    clip-path: url(#clip-path-14);
                }
                .nWall5-19 {
                    clip-path: url(#clip-path-15);
                }
            </style>
            <clipPath id="clip-path">
                <rect
                    class="nWall5-1"
                    x="143.83"
                    y="91.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-2">
                <rect
                    class="nWall5-1"
                    x="185.58"
                    y="38.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-3">
                <rect
                    class="nWall5-1"
                    x="227.08"
                    y="91.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-4">
                <rect
                    class="nWall5-1"
                    x="185.83"
                    y="144.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-5">
                <rect
                    class="nWall5-1"
                    x="102.83"
                    y="144.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-6">
                <rect
                    class="nWall5-1"
                    x="269.08"
                    y="144.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-7">
                <rect
                    class="nWall5-1"
                    x="185.83"
                    y="250.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-8">
                <rect
                    class="nWall5-1"
                    x="102.83"
                    y="250.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-9">
                <rect
                    class="nWall5-1"
                    x="19.83"
                    y="250.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-10">
                <rect
                    class="nWall5-1"
                    x="269.08"
                    y="250.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-11">
                <rect
                    class="nWall5-1"
                    x="352.08"
                    y="250.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-12">
                <rect
                    class="nWall5-1"
                    x="226.83"
                    y="197.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-13">
                <rect
                    class="nWall5-1"
                    x="310.08"
                    y="197.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-14">
                <rect
                    class="nWall5-1"
                    x="60.83"
                    y="197.66"
                    width="39"
                    height="1"
                />
            </clipPath>
            <clipPath id="clip-path-15">
                <rect
                    class="nWall5-1"
                    x="144.08"
                    y="197.66"
                    width="39"
                    height="1"
                />
            </clipPath>
        </defs>
        <g class="number-wall-5-fields">
            <g class="field1" (click)="setActiveField(0)">
                <rect
                    class="nWall5-2"
                    x="166.75"
                    y="0.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(204 34.52)"
                >
                    {{ values[0] }}
                </text>
                @if (activeField === 0) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="185.58"
                        y1="39.16"
                        x2="224.58"
                        y2="39.16"
                    />
                </g>
                }
            </g>
            <g class="field2" (click)="setActiveField(1)">
                <rect
                    class="nWall5-2"
                    x="125"
                    y="53.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(162 87.52)"
                >
                    {{ values[1] }}
                </text>
                @if (activeField === 1) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="143.83"
                        y1="92.16"
                        x2="182.83"
                        y2="92.16"
                    />
                </g>
                }
            </g>
            <g class="field3" (click)="setActiveField(2)">
                <rect
                    class="nWall5-2"
                    x="208.25"
                    y="53.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(245 87.52)"
                >
                    {{ values[2] }}
                </text>
                @if (activeField === 2) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="227.08"
                        y1="92.16"
                        x2="266.08"
                        y2="92.16"
                    />
                </g>
                }
            </g>
            <g class="field4" (click)="setActiveField(3)">
                <rect
                    class="nWall5-2"
                    x="83.75"
                    y="106.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(121 140.52)"
                >
                    {{ values[3] }}
                </text>
                @if (activeField === 3) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="102.83"
                        y1="145.16"
                        x2="141.83"
                        y2="145.16"
                    />
                </g>
                }
            </g>
            <g class="field5" (click)="setActiveField(4)">
                <rect
                    class="nWall5-2"
                    x="166.75"
                    y="106.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(204 140.52)"
                >
                    {{ values[4] }}
                </text>
                @if (activeField === 4) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="185.83"
                        y1="145.16"
                        x2="224.83"
                        y2="145.16"
                    />
                </g>
                }
            </g>
            <g class="field6" (click)="setActiveField(5)">
                <rect
                    class="nWall5-2"
                    x="249.75"
                    y="106.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(287 140.52)"
                >
                    {{ values[5] }}
                </text>
                @if (activeField === 5) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="269.08"
                        y1="145.16"
                        x2="308.08"
                        y2="145.16"
                    />
                </g>
                }
            </g>
            <g class="field7" (click)="setActiveField(6)">
                <rect
                    class="nWall5-2"
                    x="42.25"
                    y="159.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(79 193.52)"
                >
                    {{ values[6] }}
                </text>
                @if (activeField === 6) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="60.83"
                        y1="198.16"
                        x2="99.83"
                        y2="198.16"
                    />
                </g>
                }
            </g>
            <g class="field8" (click)="setActiveField(7)">
                <rect
                    class="nWall5-2"
                    x="125.25"
                    y="159.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(162 193.52)"
                >
                    {{ values[7] }}
                </text>
                @if (activeField === 7) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="144.08"
                        y1="198.16"
                        x2="183.08"
                        y2="198.16"
                    />
                </g>
                }
            </g>
            <g class="field9" (click)="setActiveField(8)">
                <rect
                    class="nWall5-2"
                    x="208.25"
                    y="159.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(245 193.52)"
                >
                    {{ values[8] }}
                </text>
                @if (activeField === 8) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="226.83"
                        y1="198.16"
                        x2="265.83"
                        y2="198.16"
                    />
                </g>
                }
            </g>
            <g class="field10" (click)="setActiveField(9)">
                <rect
                    class="nWall5-2"
                    x="291.25"
                    y="159.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(328 193.52)"
                >
                    {{ values[9] }}
                </text>
                @if (activeField === 9) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="310.08"
                        y1="198.16"
                        x2="349.08"
                        y2="198.16"
                    />
                </g>
                }
            </g>
            <g class="field11" (click)="setActiveField(10)">
                <rect
                    class="nWall5-2"
                    x="0.75"
                    y="212.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(38 246.52)"
                >
                    {{ values[10] }}
                </text>
                @if (activeField === 10) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="19.83"
                        y1="251.16"
                        x2="58.83"
                        y2="251.16"
                    />
                </g>
                }
            </g>
            <g class="field12" (click)="setActiveField(11)">
                <rect
                    class="nWall5-2"
                    x="83.75"
                    y="212.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(121 246.52)"
                >
                    {{ values[11] }}
                </text>
                @if (activeField === 11) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="102.83"
                        y1="251.16"
                        x2="141.83"
                        y2="251.16"
                    />
                </g>
                }
            </g>
            <g class="field13" (click)="setActiveField(12)">
                <rect
                    class="nWall5-2"
                    x="166.75"
                    y="212.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(204 246.52)"
                >
                    {{ values[12] }}
                </text>
                @if (activeField === 12) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="185.83"
                        y1="251.16"
                        x2="224.83"
                        y2="251.16"
                    />
                </g>
                }
            </g>
            <g class="field14" (click)="setActiveField(13)">
                <rect
                    class="nWall5-2"
                    x="249.75"
                    y="212.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(287 246.52)"
                >
                    {{ values[13] }}
                </text>
                @if (activeField === 13) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="269.08"
                        y1="251.16"
                        x2="308.08"
                        y2="251.16"
                    />
                </g>
                }
            </g>
            <g class="field15" (click)="setActiveField(14)">
                <rect
                    class="nWall5-2"
                    x="332.75"
                    y="212.75"
                    width="76.5"
                    height="46.5"
                />
                <text
                    class="nWall5-3"
                    text-anchor="middle"
                    transform="translate(370 246.52)"
                >
                    {{ values[14] }}
                </text>
                @if (activeField === 14) {
                <g>
                    <line
                        class="nWall5-5"
                        x1="352.08"
                        y1="251.16"
                        x2="391.08"
                        y2="251.16"
                    />
                </g>
                }
            </g>
        </g>
    </svg>
    }
</ng-template>
